import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TooltipDirective } from '@cloudfactorydk/ng2-tooltip-directive';
import { PopoverController } from '@ionic/angular';
import { IonPopover } from '@ionic/angular/common';
import { min } from "lodash-es";
import { CookieService } from "ngx-cookie-service";
import { OutOfStockPopoverComponent } from 'src/app/components/out-of-stock-popover/out-of-stock-popover.component';
import { ProductService } from 'src/app/shared-lib/domains/product';
import { AppService } from "../../../shared/app.service";
import { CartService } from "../../../shared/cart.service";
@Component({
  selector: 'app-print-group-folder-item',
  templateUrl: './print-group-folder-item.component.html',
  styleUrls: ['./print-group-folder-item.component.scss'],
  standalone: false
})
export class PrintGroupFolderItemComponent implements OnInit, OnDestroy {
  @Input() group;
  @Input() currentPrintProduct;
  @Input() isLoading = false;
  @Input() isMobile = false;
  @Input() inCart: boolean = false;
  @Input() inOrderDetail: boolean = false;

  @Input() isStatic = false;
  @Output() closeFoldersEvent = new EventEmitter();

  @ViewChild('outOfStockIcon', { read: ElementRef }) outOfStockIcon: ElementRef;
  @ViewChild('tooltip', { static: false }) tooltip: TooltipDirective;
  @ViewChild('tooltip2', { static: false }) tooltip2: TooltipDirective;

  constructor(
    public cartService: CartService,
    private productService: ProductService,
    public appService: AppService,
    private cookieService: CookieService,
    private popoverController: PopoverController
  ) { }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.cartService.registerPopover.asObservable().subscribe(() => {
      this.checkAndRegisterPopover();
    });
    this.checkAndRegisterPopover();
    this.appService.registerTooltip(this.tooltip);
    this.appService.registerTooltip(this.tooltip2);
  }

  ngOnDestroy() {
    this.appService.unregisterTooltip(this.tooltip);
    this.appService.unregisterTooltip(this.tooltip2);
    // Evitar dejar entradas con un nativeElement desconectado del DOM:
    // si la entrada sigue siendo válida, el siguiente folder-item visible
    // la volverá a registrar al emitirse registerPopover.
    if (this.group?.cartId) {
      const entry = this.cartService.outOfStockPopovers.get(this.group.cartId);
      const entryTarget = (entry?.event as any)?.target as HTMLElement | undefined;
      if (entryTarget && entryTarget === this.outOfStockIcon?.nativeElement) {
        this.cartService.outOfStockPopovers.delete(this.group.cartId);
      }
    }
  }

  selectGroup() {
    if (this.currentPrintProduct?.cartId === this.group.cartId || this.isLoading || this.inCart || this.isStatic) {
      return;
    }
    this.cartService.setActivePrintItem(
      this.group
    );
    this.cookieService.delete('bindingSelected');
    this.closeFoldersEvent.emit();
  }

  changeGroupQty(event) {
    this.group.qty = Math.min(9999, Math.max(1, event.qty));
    this.productService.setPrintProduct(this.group, this.group.product.printingGroup.files);
    this.cartService.refreshCartPrice();
    this.cartService.setCartBindingUses();

    if (this.cartService.exceededBindingItems(this.group.product.printingGroup).length) {
      this.checkAndRegisterPopover();
    } else {
      this.cartService.deleteOutOfStockPopover(this.group.cartId);
    }
  }

  protected readonly min = min;

  openPopover(event: Event, popover?: IonPopover): void {
    event.stopPropagation();

    popover.event = event;
    popover.present();

  }

  async openOutOfStockPopover(event: Event) {
    const popover = await this.popoverController.create({
      component: OutOfStockPopoverComponent,
      componentProps: {
        group: this.group
      },
      event: event,
      cssClass: 'out-of-stock-popover',
      showBackdrop: false,
      backdropDismiss: true
    });

    popover.present();
  }

  private checkAndRegisterPopover() {
    const exceeded = this.cartService.exceededBindingItems(this.group.product.printingGroup);
    const itemExists = this.cartService.cart.items.some(item => item.cartId === this.group.cartId);

    if (exceeded.length > 0 && this.outOfStockIcon?.nativeElement && itemExists) {
      this.cartService.registerOutOfStockPopover({
        id: this.group.cartId,
        event: { target: this.outOfStockIcon?.nativeElement } as Event,
        item: this.group
      });
    }
  }
}
